import { useState } from 'react';

export const useFetch = (initialStatus = 0) => {
    const [loading, setLoading] = useState(false);
    const [statusForm, setStatusForm] = useState(initialStatus);
    const [errorMesForm, setErrorMesForm] = useState('');
    const [isOpenModalSuccess, setIsOpenModalSuccess] = useState(false);
    const [isOpenModalError, setIsOpenModalError] = useState(false);
    const [isOpenModalErrorDate, setIsOpenModalErrorDate] = useState(false);

    const fetchClient = async (url, method, body, resetForm) => {
        setLoading(true);
        try {
            const response = await fetch(url, {
                method,
                body,
            })

            const responseData = await response.json(); // Парсим JSON ответ

            if (response.ok) {
                // console.log(responseData);
                setTimeout(() => {
                    resetForm(); // метод resetForm() предоставляет библиотека Formik
                    setLoading(false);
                    // setStatusForm(2);
                    // setIsOpenModalSuccess(true);
                    // Проверяем order_type_id из ответа
                    if (responseData.order_type_id === 1 || responseData.order_type_id === '1') {
                        setStatusForm(2);
                        setIsOpenModalSuccess(true);
                    } else if ((responseData.order_type_id === 2 || responseData.order_type_id === '2') && responseData.redirect) {
                        // Делаем редирект
                        window.location.href = responseData.redirect;
                    } else {
                        // Дефолтное поведение, если не указан order_type_id или он не 1/2
                        setStatusForm(2);
                        setIsOpenModalSuccess(true);
                    }
                }, 600);
                // } else if (response.status === 403) {
                //     const errorText = await response.text();
                //     console.error('Error:', errorText);
                //     setTimeout(() => {
                //         setLoading(false);
                //         // setStatusForm(4);
                //         // setErrorMesForm(errorText);
                //         setStatusForm(4);
                //         setIsOpenModalErrorDate(true);
                //     }, 600);
                // } else {
                //     const errorText = await response.text();
                //     console.error('Error:', errorText);
                //     setTimeout(() => {
                //         setLoading(false);
                //         // setStatusForm(4);
                //         // setErrorMesForm(errorText);
                //         setStatusForm(3);
                //         setIsOpenModalError(true);
                //     }, 600);
                // }
                // } catch (error) {
                //     console.error('Error:', error);
                //     setTimeout(() => {
                //         setLoading(false);
                //         setStatusForm(3);
                //         setIsOpenModalError(true);
                //     }, 600);
                // }
            } else {
                // Обработка ошибок при !response.ok
                const errorText = responseData.message || JSON.stringify(responseData);
                // console.error('Error:', errorText);
                setTimeout(() => {
                    setLoading(false);
                    setErrorMesForm(errorText); // Устанавливаем текст ошибки
                    setIsOpenModalError(true);
                    setStatusForm(3);
                    // if (response.status === 403) {
                    //     setStatusForm(4);
                    //     setIsOpenModalErrorDate(true);
                    // } else {
                    //     setStatusForm(3);
                    //     setIsOpenModalError(true);
                    // }
                }, 600);
            }
        } catch (error) {
            // console.error('Error:', error);
            setTimeout(() => {
                setLoading(false);
                setErrorMesForm(error.message); // Устанавливаем текст ошибки
                setStatusForm(3);
                setIsOpenModalError(true);
            }, 600);
        }
    };

    return {
        loading,
        statusForm,
        setStatusForm,
        errorMesForm,
        isOpenModalSuccess,
        isOpenModalError,
        isOpenModalErrorDate,
        fetchClient,
        setIsOpenModalSuccess,
        setIsOpenModalError,
        setIsOpenModalErrorDate,
    };
};
